module.exports.STATE = "state";
module.exports.COUNTY = "county";
module.exports.NATIONAL = "national";